<script>
  // @ts-check
  import Accordion from "../../molecules/Accordion/Accordion.svelte";

  import TertiaryNavigationItem from "./TertiaryNavigationItem.svelte";

  /** Primarily used for testing
   * @type {string} */
  export let id = undefined;

  /** The Accordion props
   * @type {TertiaryNavigationItemListType[]} */
  export let items = [];

  /** @type {string}  Choose which one is the active route*/
  export let currentRoute = "";

  $: navItems = items.map((item) => {
    return {
      ...item,
      body: TertiaryNavigationItem,
      bodyProps: { currentRoute, links: item.links },
      active: item.links.some((link) => link.url === currentRoute)
    };
  });
</script>

<nav {id} class="override-item w-full border-b-thin">
  <Accordion
    itemContainerClass="override-[item]:py-4 lg:override-[item]:py-4"
    items={navItems}
    itemBodySlotClass="override-[item]:pt-4 lg:override-[item]:pt-4"
  />
</nav>
